<template>
  <v-card class="elevation-2" :disabled="item.isPassoBloqueado" :key="`passos-${chave}-${item.id}`">
    <v-main v-if="!isPassoParalelo" class="pa-0 ma-0">
      <v-row class="pa-0 ma-0">
        <v-col class="title pb-0 mb-0" :class="{'grey--text text--darken-1': textoCinza(item)}">
          <span v-if="itemPossuiDescricao(item)" v-html="`${ $tc('label.passo', 1) } ${ item.sequencia } - ${ item.descricao }`" />
          <span v-else v-html="`${ $tc('label.passo', 1) } ${ item.sequencia }`" />
        </v-col>
      </v-row>
    </v-main>
<v-card-title class="title historico_header px-3 py-2" :class="{'grey--text text--darken-1': textoCinza(item)}">
      <div class="title" v-if="item.usuarioAprovador">
        <span v-if="usuarioFornecedor && !item.usuarioAprovador.grupo.includes('Fornecedor')">
          {{ $t('label.status_por', { status: formatarStatus(item.statusPasso) }) + ' ' + item.usuarioAprovador.grupo}}
        </span>
        <span v-else>
          {{ $t('label.status_por', { status: formatarStatus(item.statusPasso) }) + ' ' + item.usuarioAprovador.nome + ' ' +
        item.usuarioAprovador.sobrenome}}
        </span>
      </div>
      <div class="title" v-if="transferido(item)">
        {{ $t('label.aprovador_anterior') }}
      </div>

      <v-spacer></v-spacer>
      <slot name="historico"></slot>
    </v-card-title>

<v-card-text class="historico_body" :class="{'grey--text text--darken-1': textoCinza(item)}">
      <v-row v-if="aguardandoAprovacao(item) || transferido(item)">
        <v-col cols="12" class="pa-0">
          <v-list two-line class="pa-0">
<v-row class="ma-0">

<v-col cols="12" sm="6" class="pa-0">
                <template v-if="item.isPassoBloqueado">
                  <v-list-item>
                    <v-list-item-avatar>
                      <v-icon color="grey">group_work</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>{{ item.perfil || nomePerfilUsuarioAprovador(item) }}</v-list-item-title>
                      <v-list-item-subtitle>{{ $tc('label.perfil', 1) }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>

                <template v-if="!item.isPassoBloqueado && item.usuariosAprovadores && item.usuariosAprovadores.grupos
                 && item.usuariosAprovadores.grupos.length > 0">
                  <v-list-item v-for="(grupo, pIndex) in item.usuariosAprovadores.grupos" :key="`${chave}-grp-${grupo.id}-${pIndex}`">
                    <v-list-item-avatar>
                      <v-icon v-if="pIndex === 0" color="primary">group_work</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title v-if="isPassoFornecedor(item) && ehContrato">
                        {{ grupo.nome + ' - ' + $tc('label.tipos_fornecedor.' + item.tipoFornecedor.toLowerCase(), 1) }}
                      </v-list-item-title>
                      <v-list-item-title v-else>{{ grupo.nome }}</v-list-item-title>
                      <v-list-item-subtitle>{{ $tc('label.perfil', 1) }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>

                <template v-if="!item.isPassoBloqueado && (!item.usuariosAprovadores || !item.usuariosAprovadores.grupos
                 || item.usuariosAprovadores.grupos.length === 0)">
                  <v-list-item>
                    <v-list-item-avatar>
                      <v-icon color="primary">group_work</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>{{ item.perfil || nomePerfilUsuarioAprovador(item) }}</v-list-item-title>
                      <v-list-item-subtitle>{{ $tc('label.perfil', 1) }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>

              </v-col>

<v-col cols="12" sm="6" class="pa-0">

                <template v-if="item.usuariosAprovadores && item.usuariosAprovadores.usuarios && item.usuariosAprovadores.usuarios.length > 0">
                  <v-list-item v-for="(usuario, uIndex) in item.usuariosAprovadores.usuarios" :key="`${chave}-usr-${usuario.id}-${uIndex}`">
                    <v-list-item-avatar>
                      <v-icon v-if="uIndex === 0 && item.usuariosAprovadores.usuarios.length == 1" :color="item.isPassoBloqueado ? 'grey' : 'primary'">person</v-icon>
                      <v-icon v-if="uIndex === 0 && item.usuariosAprovadores.usuarios.length > 1" :color="item.isPassoBloqueado ? 'grey' : 'primary'">group</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title v-if="usuarioFornecedor && !isPassoFornecedor(item)">{{ usuario.grupo }}</v-list-item-title>
                      <v-list-item-title v-else>{{ usuario.nome }}</v-list-item-title>
                      <v-list-item-subtitle>{{ $tc('label.usuario', 1) }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>

                <template v-if="item.usuariosAprovadores && item.usuariosAprovadores.subgrupos && item.usuariosAprovadores.subgrupos.length > 0">
                  <v-list-item v-for="(subgrupo, eIndex) in item.usuariosAprovadores.subgrupos" :key="`${chave}-sub-${subgrupo.id}-${eIndex}`">
                    <v-list-item-avatar>
                      <v-icon v-if="eIndex === 0" :color="item.isPassoBloqueado ? 'grey' : 'primary'">person</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>{{subgrupo.nome}}</v-list-item-title>
                      <v-list-item-subtitle>{{ $tc('label.estrutura_usuario', 0) }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>

              </v-col>

            </v-row>
          </v-list>
        </v-col>
      </v-row>

      <v-row v-if="transferido(item)" class="px-3 py-2">
        <span><b class="pr-1">{{ $t('label.transferido_por') }}:</b></span>
        <span>{{ item.usuarioTransferenciaPasso.usuarioTransferencia }}</span>
      </v-row>
      <v-row v-if="transferido(item)" class="px-3 py-2">
        <span><b class="pr-1">{{ $t('label.data_transferencia') }}:</b></span>
        <span>{{ item.usuarioTransferenciaPasso.dtaTransferencia}}</span>
      </v-row>
      <v-col cols="12" class="pa-0 pt-2">
          <v-list two-line class="pa-0">
            <v-row class="ma-0">

              <v-col cols="12" sm="6" class="pa-0" :class="{'grey--text text--darken-1': textoCinza(item)}">
                <v-row v-if="!aguardandoAprovacao(item) && !transferido(item)" class="px-3 py-2">
                  <span><b class="pr-1">{{ $t('label.data') }}:</b></span>
                  <span v-if="item.dtaAvaliacao">{{ toDate(item.dtaAvaliacao) }}</span>
                  <span v-else>{{ $t('label.data_indefinida') }}</span>
                </v-row>
              </v-col>
              <v-col cols="12" sm="6" class="pa-0" :class="{'grey--text text--darken-1': textoCinza(item)}">
                <v-row v-if="!aguardandoAprovacao(item) && !transferido(item)" class="px-3 py-2">
                  <span><b class="pr-1">{{ $tc('label.perfil', 1) }}: </b></span>
                  <span>{{ item.perfil? item.perfil : nomePerfilUsuarioAprovador(item) }}</span>
                </v-row>
              </v-col>
            </v-row>
          </v-list>
      </v-col>

      <v-row v-if="item.observacao" class="px-3 py-6">
        <span><b class="pr-1">{{ $tc('label.observacao', 1) }}:</b></span>
        <span>{{ item.observacao }}</span>
      </v-row>
      <v-row v-if="item.dados" v-for="(dados, xIndex) in item.dados" :key="`${chave}-dados-${xIndex}`" class="px-3 py-2">
        <span> {{ dados }} </span>
      </v-row>
      <v-row class="ma-0 pt-6 pr-2" justify="end" v-if="item.isProximoPasso && !ehRepresentanteLegal">
        <v-btn
          @click.native="reenviarEmailAprovacao(item)"
          small
          color="primary"
        >
          {{ $t('label.reenviar_email_aprovacao') }}
        </v-btn>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import PopoverLista from '../PopoverLista';

export default {
  components: {
    PopoverLista,
  },
  name: 'AcompanhamentoItem',
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    entidade: String,
    idEntidade: Number,
    chave: String,
    isPassoParalelo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      resourceFluxo: this.$api.fluxoAprovacao(this.$resource),
    };
  },
  watch: {
  },
  computed: {
    ...mapGetters('usuario', [
      'usuarioLogado',
    ]),
    ehContrato() {
      return this.entidade === 'CONTRATO';
    },
    ehRepresentanteLegal() {
      return this.entidade === 'REPRESENTANTE_LEGAL';
    },
    usuarioFornecedor() {
      return this.usuarioLogado.tipo === 'FORNECEDOR';
    },
  },
  methods: {
    aguardandoAprovacao(passo) {
      return passo.statusPasso === 'AGUARDANDO_APROVACAO';
    },
    emAnalise(passo) {
      return passo.statusPasso === 'EM_ANALISE';
    },
    transferido(passo) {
      return passo.statusPasso === 'TRANSFERIDO';
    },
    toDate(data) {
      const formatos = ['DD/MM/YYYY HH:mm:ss', moment.ISO_8601];
      return moment(data, formatos, true).format('DD-MM-YYYY HH:mm:ss');
    },
    isPassoFornecedor(item) {
      return item.tipoFornecedor !== undefined;
    },
    reprovado(passo) {
      return passo.statusPasso === 'REPROVADO';
    },
    textoCinza(passo) {
      return this.emAnalise(passo);
    },
    nomePerfilUsuarioAprovador(item) {
      if (item.usuarioAprovador) {
        return item.usuarioAprovador.grupo;
      }
      if (item.usuariosAprovadores && item.usuariosAprovadores.grupos && item.usuariosAprovadores.grupos.length > 0) {
        return item.usuariosAprovadores.grupos[0].nome;
      }
      if (item.tipoFornecedor) {
        return 'Fornecedor';
      }
      return '';
    },
    reenviarEmailAprovacao(item) {
      const parametros = {
        idPasso: item.id,
        entidade: this.entidade,
      };
      this.resourceFluxo.reenviarEmailAprovacao(parametros, {})
        .then(() => {
          this.$toast(this.$t('message.email_reenviado'));
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    formatarStatus(status) {
      return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase().replaceAll('_', ' ');
    },
    itemPossuiDescricao(item) {
      return item.descricao !== undefined && item.descricao !== null;
    },
  },
  mounted() {
  },
};
</script>
